export const CANONICAL_SALES_PATH = "/subscribe";
export const CANONICAL_SALES_URL = `https://katarza.tv${CANONICAL_SALES_PATH}`;
export const LEGACY_SALES_PATHS = ["/pretplata"];

export const buildCanonicalSalesPath = ({ search = "", hash = "" } = {}) =>
  `${CANONICAL_SALES_PATH}${search}${hash}`;
